import { deepClone, debounce } from '@lsfe/tools';

const _processEnumData = (data, dicCode, dicAllValue) => {
    if (!dicCode || typeof data !== 'object') return data;
    if (!data[dicCode]) return data;
    data = data[dicCode].dictionaryValueList.map(item => ({
        label: item.name,
        value: item.key
    }));
    if (dicAllValue) data.unshift({ label: '全部', value: dicAllValue });
    return data;
};

const _genDicRemoteConfig = dicCode => ({
    type: 'hPost',
    url: '/api/m/tms/mapi/dictionary/batchGetDictionaryAndValue',
    params: {
        dicCodes: [dicCode]
    },
    options: {
        cache: true
    }
});

const genMixin = opts => ({
    props: {
        /**
         * 远程数据源配置，参考 request
         * {
         *   type: String,
         *   url: String,
         *   params: Object,
         *   options: Object
         * }
         */
        remoteConfig: {
            type: Object
        },
        /**
         * 远程数据是否自动加载
         */
        autoLoad: {
            type: Boolean,
            default: true
        },
        /**
         * 远程返回数据处理 hook
         * @return 处理后的数据
         */
        responseProcessor: {
            type: Function,
            default: res => res
        },
        /**
         *
         */
        dicCode: {
            type: String
        },
        dicAllValue: {
            type: [Number, String]
        }
    },
    watch: {
        remoteConfig: {
            deep: true,
            handler(val) {
                this.$_remoteConfig = val;
                if (this.autoLoad) this.debouncedFetchData();
            }
        },
        dicCode(val) {
            this.$_remoteConfig = _genDicRemoteConfig(val);
            if (this.autoLoad) this.debouncedFetchData();
        }
    },
    data() {
        return {
            $_remoteConfig: {}
        };
    },
    methods: {
        /**
         * 加载远程数据
         */
        fetchData() {
            if (!this.$_remoteConfig || !this.$_remoteConfig.url) {
                return;
                // throw new Error('请设置 remoteConfig.url');
            }
            const { type = 'hPost', url = '', params = {}, options = {} } = this.$_remoteConfig;
            this[`$${type}`](url, params, options).then(data => {
                data = _processEnumData(data, this.dicCode, this.dicAllValue);
                data = this.responseProcessor(data);
                this.$emit('loaded', deepClone(data));
                if (opts.prop) this[opts.prop] = data;
                if (this.$_remoteDataLoaded) this.$_remoteDataLoaded(data);
            });
        }
    },
    created() {
        this.debouncedFetchData = debounce(this.fetchData, 500);
        if (this.dicCode) this.$_remoteConfig = _genDicRemoteConfig(this.dicCode);
        else if (this.remoteConfig) this.$_remoteConfig = this.remoteConfig;
        if (this.autoLoad) this.fetchData();
    }
});

/**
 * @param {Object} opts 配置项
 * @param {String} opts.prop 数据加载成功后，会自动赋值到组件状态中的这个属性（this[opt.prop]）
 */
export default function(opts = {}) {
    return genMixin(opts);
}
